import React, { Suspense, useTransition } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Layout } from "./components/Layout/Layout";
import "./custom.css";
import { Login } from "./components/Login/Login";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import MiniMenu from "./components/Menu/MiniMenu";
import { NavMenu } from "./components/Menu/NavMenu";
import DaoTrangList from "./components/DaoTrangList/DaoTrangList";
import { BigSpin } from "./components/DaoTrang/BigSpin";
import DaoTrang from "./components/DaoTrang/DaoTrang";
import BCS from "./components/Bcs/Bcs";
import BcsEdit from "./components/BcsEdit/BcsEdit";
import UserEdit from "./components/DaoTrang/UserEdit";
import {
  logout,
  selectRoleObj,
  selectToken,
  selectUsername,
  setRoleObj,
} from "./features/auth/authSlice";
import {
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ThanhPhan from "./components/ThanhPhan/ThanhPhan";
import To from "./components/To/To";
import DK from "./components/DK/DK";
import { Chat } from "./components/Chat/Chat";
import { useEffect } from "react";
import { getRole } from "./services/role/roleApi";
import { useState } from "react";
import Btc from "./components/BtcUserDk/Btc";
const pageStack = [{ pathname: "/", params: {} }];

function App({ path }) {
  return (
    <Suspense fallback={<BigSpin />}>
      <Router path={path} />
    </Suspense>
  );
}
function Router({ path = "" }) {
  const location = useLocation();
  // console.log(location.pathname, location.state);

  // const [page, setPage] = useState({ pathname: path, params: {} });
  const [isPending, startTransition] = useTransition();
  const token = useAppSelector(selectToken);
  const email = useAppSelector(selectUsername);
  const dispatch = useAppDispatch();
  let navi = useNavigate();
  const roleObj = useAppSelector(selectRoleObj);
  /**
   * ページに移動する
   * @param {string} url
   * @param {object} params
   * @return なし
   */
  function navigate(url, params) {
    // console.log("params ", params)
    startTransition(() => {
      if (url === -1) {
        navi(-1);
      } else {
        navi(url, { state: params });
      }
    });
  }

  let { pathname: url, state: params } = location;
  // let { pathname: url, state: params } = page;

  if (!params) {
    params = {};
  }
  // for debug
  const [searchParams] = useSearchParams();
  // console.log("searchParams", searchParams);
  searchParams.forEach((v, k) => (params[k] = v));

  let content;

  const [pending, setPending] = useState(true);
  useEffect(() => {
    async function fetchRole() {
      if (token && email) {
        // {btc: user|admin}
        var { result: roleObj } = await getRole(email);
        console.log("getRole return: ", roleObj);
        if (roleObj) {
          dispatch(setRoleObj({ roleObj: roleObj }));
        }
      }

      setPending(false);
    }
    fetchRole();
  }, [dispatch, email, token]);

  if (pending) {
    return <>Loading...</>;
  }

  // for debug: direct open login page

  if (!token) {
    return <Login></Login>;
  }

  // auth user
  if (url === "/" || url.match(/^\/Btc/i)) {
    return <Btc url={url} navigate={navigate} params={params} ></Btc>
  }

  // admin
  if (roleObj.sys !== "admin") {
    return <></>;
  }

  if (url.match(/DaoTrangList/i)) {
    content = <DaoTrangList navigate={navigate} params={params} />;
  } else if (url.match(/bcsEdit/i)) {
    content = <BcsEdit navigate={navigate} params={params} />;
  } else if (url.match(/Bcs/i)) {
    content = <BCS navigate={navigate} params={params} />;
  } else if (url.match(/TP/i)) {
    content = <ThanhPhan navigate={navigate} params={params} />;
  } else if (url.match(/To/i)) {
    content = <To navigate={navigate} params={params} />;
  } else if (url.match(/GroupAdd/i)) {
    content = <BcsEdit navigate={navigate} params={params} />;
  } else if (url.match(/DaoTrang/i)) {
    content = <DaoTrang navigate={navigate} params={params} />;
  } else if (url.match(/UserEdit/i)) {
    content = <UserEdit navigate={navigate} params={params} />;
  } else if (url.match(/UserAdd/i)) {
    content = <UserEdit navigate={navigate} params={params} />;
  } else if (url.match(/^\/DK$/i)) {
    content = <DK navigate={navigate} params={params} />;
  } else if (url.match(/^\/Chat$/i)) {
    return <Chat navigate={navigate} params={params} />;
  } else {
    content = <DaoTrangList navigate={navigate} params={params} />;
  }

  const header = (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      justifyItems={"center"}
      spacing={2}
    >
      {pageStack.length > 1 ? (
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIcon></ArrowBackIcon>
        </IconButton>
      ) : (
        <div></div>
      )}
      <Button
        onClick={() => {
          dispatch(logout());
        }}
        endIcon={<LogoutIcon />}
      >
        {email}
      </Button>
    </Stack>
  );

  const menu = <NavMenu navigate={navigate}></NavMenu>;
  // const menu = <MiniMenu navigate={navigate} />;

  return true ? (
    <Layout
      isPending={isPending}
      navigate={navigate}
      menu={menu}
      header={header}
    >
      {content}
    </Layout>
  ) : (
    <MiniMenu navigate={navigate}>{content}</MiniMenu>
  );
}

export default App;
